import logo from "../../../assets/images/logo-izitrack.jpeg";

const Logo = ({ className = "", style = {} }) => {
  return (
    <img
      src={logo}
      alt="Logo"
      className={`img-fluid mx-auto d-block ${className}`}
      style={{ maxWidth: "160px", height: "auto", ...style }}
    />
  );
};

export default Logo;
